import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import type {ReactNode} from 'react';

import {ConfirmProvider} from '@/components/confirm-dialog/useConfirm';
import DevRoleSwitcher from '@/components/DevRoleSwitcher';
import MaintenanceBanner from '@/components/MaintenanceBanner';
import OfflineStatusBanner from '@/components/OfflineStatusBanner';
import QueryGlobalLoader from '@/components/QueryGlobalLoader';
import {Toaster} from '@/components/ui/toaster';
import {TooltipProvider} from '@/components/ui/tooltip';
import queryClient from '@/services/queryClient';

export type ShellProvidersProps = {
  children: ReactNode;
};

const RootProviders = ({children}: ShellProvidersProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <QueryGlobalLoader />
      <TooltipProvider delayDuration={100}>
        <ConfirmProvider>{children}</ConfirmProvider>
      </TooltipProvider>
      <Toaster />
      <OfflineStatusBanner />
      <MaintenanceBanner />
      <ReactQueryDevtools buttonPosition="bottom-left" />
      {import.meta.env.DEV && <DevRoleSwitcher />}
    </QueryClientProvider>
  );
};

export default RootProviders;
